import React, { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ModalProvider } from './contexts/ModalContext';
import AppRoutes from './routes/AppRoutes';
import SiteHeader from './components/layout/SiteHeader';
import SiteFooter from './components/layout/SiteFooter';
import { isPublicBrowsePath } from './components/layout/PublicHeader';
import ContactFab from './components/layout/ContactFab';
import { ComingSoonProvider } from './contexts/ComingSoonContext';
import AlertInitializer from './components/common/AlertInitializer';
import { POLICY_PATHS } from './config/policies';

const Layout = () => {
  const { isLoggedIn } = useAuth();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="App">
      <SiteHeader />
      <AppRoutes />
      {((isLoggedIn && pathname !== '/login') || (!isLoggedIn && (pathname === '/' || isPublicBrowsePath(pathname))) || POLICY_PATHS.includes(pathname)) && <SiteFooter />}
      <ContactFab />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ModalProvider>
          <ComingSoonProvider>
            <AlertInitializer />
            <Layout />
          </ComingSoonProvider>
        </ModalProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
